export default {"src":"__ASTRO_ASSET_IMAGE__CxkEvI4p__","width":513,"height":342,"format":"svg"}